import React from 'react';
import { ENDPOINT } from './config.js';
import normalizeFont from './normalizeFont.js';

/**
 * Generates preload elements for all given fonts that pass in a n4 woff2
 * @param fonts {Font[]} the font family or families to define
 * @param variants {Variant[]} the variant to define
 * @param formats {Format[]} the format(s) to define
 * @returns {React.ReactElement[] | void} the link node(s) if created
 *
 * Preload is only implemented for the woff2 format, normal weight, normal variant fonts.
 * This is a happy path optimization that will attempt to load a default font ASAP, relegating any others to a later stage.
 *
 * [1] If not Helvetica For Target, return
 * [2] Only optimize n4 variants, it being the default style and weight.
 * [3] Only optimize the delivery of woff2 formats
 * [4] Create the preload link
 */

var createPreLoad = function createPreLoad(fonts, variants, formats) {
  if (!fonts.includes('Helvetica For Target')) {
    // [1]
    return;
  }

  if (variants.includes('n4')) {
    // [2]
    var links_1 = [];
    fonts.forEach(function (font) {
      formats.filter(function (f) {
        return f === 'woff2';
      }) // [3] debatable whether or not to do this - it will prioritize woff2 users (non IE)
      .forEach(function (format) {
        // [4] here can only be one, so they say
        links_1.push(React.createElement("link", {
          rel: "preload",
          href: "" + ENDPOINT + normalizeFont(font) + "/n4/" + format,
          as: "font",
          type: "font/" + format,
          crossOrigin: "",
          key: "font_" + font + "_" + format
        }));
      });
    });
    return links_1;
  }
};

export default createPreLoad;
